<script setup lang="ts">
  import { VueFinalModal } from 'vue-final-modal';
  import SuccessIcon from '@/shared/assets/icons/SuccessIcon.svg';
  import { IconImage, ColoredButton, UiModalHeader } from '@/shared/ui';

  defineProps<{
    title: string;
    description: string;
  }>();

  const emit = defineEmits<{
    (e: 'close'): void;
  }>();
</script>

<template>
  <VueFinalModal
    class="flex justify-center items-center"
    content-class="flex flex-col bg-white-01 rounded-2xl w-1/3"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <UiModalHeader
      class="px-6 py-4 text-sm"
      @close="emit('close')"
    />
    <div
      id="modal-content"
      class="flex flex-col items-center px-14 pb-10"
    >
      <IconImage
        :src="SuccessIcon"
        alt="Success"
        class="w-11 h-11s mb-7"
      />
      <p class="text-2xl font-medium xl:whitespace-nowrap">
        {{ title }}
      </p>
      <p class="text-sm text-gray-03">
        {{ description }}
      </p>
      <ColoredButton
        class="!bg-green-19 mt-7"
        text="Ok"
        @click="emit('close')"
      />
    </div>
  </VueFinalModal>
</template>
